enum ListType {
  Table = 'table',
  Assignment = 'assignment'
}

export default ListType
